import styled from '@emotion/styled';
import { Button } from '@uniquegood/realworld-studio-design';

interface ComparisonToggleProps {
  isOpen: boolean;
  onClick: () => void;
}

const ComparisonToggle = ({ isOpen, onClick }: ComparisonToggleProps) => {
  return (
    <Container>
      <Button onClick={onClick} type="outlineBasic" size="large">
        {isOpen ? '비교표 닫기' : '더 자세히 비교하기'}
      </Button>
    </Container>
  );
};

export default ComparisonToggle;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 24px 60px 24px;
`;
